import styled from "styled-components";
import { BodyM, HeadlineH2 } from "../../library/utilities/fonts";
import { ButtonBlock } from "../../library/symbols/buttons";
import { motion } from "framer-motion";
import { breakpointRuleTablet } from "../../library/utilities/variables";
import React from "react";
const IntroSectionWrapper = styled(motion.div) `
    display: flex;
    flex-direction: column;
    align-items: center;

    max-width: 890px;
    margin: 0 auto;
    padding-top: 52px;

    min-height: 667px;

    @media (${breakpointRuleTablet}) {
        padding-top: 92px;
    }
`;
const IntroSectionTitle = styled(HeadlineH2).attrs({ as: 'h1' }) `
    text-align: center;

    margin-bottom: 24px;
`;
const IntroSectionBody = styled(BodyM) `
    max-width: 572px;
    margin: 0 auto 48px;
    text-align: center;
`;
const IntroSectionButton = styled(ButtonBlock) `
    @media (${breakpointRuleTablet}) {
        width: auto;
        padding-left: 88px;
        padding-right: 88px;
    }
`;
export function IntroductionSection({ onQuizStarted }) {
    return (React.createElement(IntroSectionWrapper, null,
        React.createElement(IntroSectionTitle, null,
            "\u00A1Hola!",
            React.createElement("br", null),
            "Queremos ayudarte a sumergirte en el mundo de la tecnolog\u00EDa"),
        React.createElement(IntroSectionBody, null, "La clave ser\u00E1 conocer tus necesidades y expectativas. Para ello, te haremos algunas preguntas importantes para poder acompa\u00F1arte en este proceso."),
        React.createElement(IntroSectionButton, { onClick: () => onQuizStarted(true) }, "Empezar")));
}
